/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Delete_TitleInputs */



/**
* | output |
* | --- |
* | "Delete API Key" |
*
* @param {Options_Api_Keys_Delete_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_delete_title = /** @type {((inputs?: Options_Api_Keys_Delete_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Delete_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer la clé API")
	if (locale === "de") return /** @type {LocalizedString} */ ("API-Schlüssel löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina la chiave API")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить ключ API")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar clave API")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除 API 密钥")
	if (locale === "ja") return /** @type {LocalizedString} */ ("APIキーを削除する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एपीआई कुंजी हटाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir chave de API")
	return /** @type {LocalizedString} */ ("Delete API Key")
});